// Chart-type values used by the IA analysis report pages (HCI-4331).
export const ChartType = Object.freeze({
  // Historical value: renders a *grouped* (non-stacked) column chart.
  GroupedColumn: "stackedColumn",
  Pie: "pie",
  Line: "line",
  // Stacked column: primary group = columns, secondary group = stacks,
  // no time horizon (totals cover the whole filtered period).
  SecondaryGroupStacked: "secondaryGroupStacked",
});

// UI label -> infection-case-api SecondaryGroupBy enum value.
export const SecondaryGroupOptions = Object.freeze({
  "Case Status": "caseStatus",
  Origin: "origin",
  Outcome: "outcome",
});

export const DEFAULT_SECONDARY_GROUP_BY_LABEL = "Case Status";

// Rate-type sentinels sent as `rateType` (see FiltersSection.vue's residentDaysRate
// options). The infection-case-api rejects Prevalence + secondaryGroupBy together.
export const RateType = Object.freeze({
  Incidence: "i",
  Prevalence: "p",
});
